module.exports = __webpack_public_path__ + "img/Dantam Hair 31b.57d65345.jpg";